import src from "IMAGE";
export default { src, width: 1440, height: 400, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAP0lEQVR42gWAAQqAIAwA/U8UJGTmdDqb/f9HF6H2STwjSYwyFlmdXI2hiq+PcN2JY98QEdp4eZqRS6V1Q6fzA2wdGy0u60QXAAAAAElFTkSuQmCC"};
